module.exports = __webpack_public_path__ + "img/check-yellow.46bb5d6d.svg";